import { pick } from 'lodash/fp';

import config from '@config';

import createDataSource from './createDataSource';
import { getDefaultEmptyList, getDefaultListHandler } from './utils';

const BASE_PATHNAME = 'posts';

const LIVE_BLOG_POSTS_UPDATED = `
  mutation LiveBlogPostUpdated($id: String!){
    liveBlogPostUpdated(id: $id) {
      parentId
      liveBlogPosts {
        id
        parentId
        liveBlogId
        postId
        language
        title
        imageId
        imageEdited
        text
        dateTime
      }
    }
  }
`;

export default () => {
  const appsyncDataSource = createDataSource(config.appsync.url, { apiPathname: '', authorizationPrefix: null });
  const dataSource = createDataSource(`${config.api.url}`);

  const triggerPublishMutation = async ({ id }) => {
    try {
      await appsyncDataSource.post('', { json: { query: LIVE_BLOG_POSTS_UPDATED, variables: { id } } });
    } catch (e) {
      console.error(`Failed to trigger publish mutation for post: '${id}'`);
    }
  };

  const getById = ({ id }) => dataSource.get(`${BASE_PATHNAME}/${id}`).json();

  const create = ({ parentId, parentType, values, liveBlogId }) =>
    dataSource.post(`${BASE_PATHNAME}`, { json: { ...values, parentId, parentType, liveBlogId } }).json();
  const update = ({ parentId, parentType, id, values, liveBlogId, language }) =>
    dataSource.put(`${BASE_PATHNAME}`, { json: { ...values, parentId, parentType, liveBlogId, id, language } }).json();

  const upsert = (options) => (options.id ? update(options) : create(options));

  const publish = async (options) => {
    const post = await upsert(options);
    const res = await dataSource.put(`${BASE_PATHNAME}/${post.id}/publish`).json();
    triggerPublishMutation({ id: post.id });
    return res;
  };
  const unpublish = async ({ id, language }) => {
    const res = await dataSource.put(`${BASE_PATHNAME}/${id}/${language}/unpublish`).json();
    triggerPublishMutation({ id });
    return res;
  };

  return {
    getList: getDefaultListHandler({
      url: BASE_PATHNAME,
      dataSource,
      transformFilter: pick(['parentId', 'parentType', 'liveBlogId']),
    }),

    getById,

    create,

    update,

    upsert,

    publish,

    unpublish,

    getEmptyList: getDefaultEmptyList,
  };
};
